export function sortByDate(a: string, b: string) {
  // Sort by date. Soonest date first. No date last
  return (Date.parse(b) || 0) - (Date.parse(a) || 0);
}

export function sortByName(a: string, b: string) {
  return a.localeCompare(b);
}
